import { DataGridHead, DataGridHeader, DataGridRow } from '@twilio-paste/core/data-grid';

export function ScopesTableHeader() {
  return (
    <DataGridHead>
      <DataGridRow>
        <DataGridHeader>Scope Name</DataGridHeader>
        <DataGridHeader>Keyword</DataGridHeader>
        <DataGridHeader>Scope ID</DataGridHeader>
        <DataGridHeader>App Name</DataGridHeader>
        <DataGridHeader textAlign="center">Actions</DataGridHeader>
      </DataGridRow>
    </DataGridHead>
  );
}
